import React from 'react'
import ReactMarkdown from 'react-markdown';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from "@mui/material/LinearProgress";



const DeleteDialog: React.FC<{
    open: boolean;
    title: string;
    body: string;
    loading: boolean;
    buttonLeft?: string;
    onClose:  ((event: {}, reason: "backdropClick" | "escapeKeyDown" | "buttonClick", ans: number) => void);
    buttonRight?: string;
}> = ({open, title, body, loading, onClose = () => {}, buttonLeft = "Cancel", buttonRight = "Continue"}) => {
    return (
        <Dialog
        open={open}
        onClose={(e, r) => {
            onClose(e, r, 0);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
         {loading && (<LinearProgress />)}
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <ReactMarkdown linkTarget={"_blank"} >
          {body}
          </ReactMarkdown>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => {
              onClose(e, "buttonClick", 1);
          }}>{buttonLeft}</Button>
          <Button onClick={(e) => {
              onClose(e, "buttonClick", 2);
          }} autoFocus>
           {buttonRight}
          </Button>
        </DialogActions>
      </Dialog>
    )
}

export default DeleteDialog
